import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import {
  getSubVendor,
  patchUpdateSubVendor,
  postAddSubVendor,
} from "redux/actions/UserSubVendor";
import {
  getVendoruser,
  patchUpdateVendor,
  postAddVendor,
} from "redux/actions/UserVendor";
import {
  getDriver,
  patchUpdateDriver,
  postAddDriver,
} from "redux/actions/UserDriver";
import {
  getVehicle,
  patchUpdateVehicle,
  postAddVehicle,
} from "redux/actions/UserVehicle";
import { getCar } from "redux/actions/UserCar";
import { getOnBoardCompliance } from "redux/actions/UserCompliance";
import { getServiceCity } from "redux/actions/UserServiceCity";
import CommonDialog from "components/commonDialog/CommonDialog";
import CommonMultiImageForm from "components/commonMultiImageForm/CommonMultiImageForm";
import TabVendor from "./TabVendor";
import Breadcrumb from "pages/vendor/BreadCrumb";
import {
  driverDialogData,
  vendorDialogData,
  subVendorDialogData,
  vehicleDialogData,
  filterStatusVehicle,
  filterStatusData,
} from "pages/vendor/VendorBreadCrumbData";

function ViewVendor() {
  let vendorStatus = JSON.parse(localStorage.getItem("vendorStatus"));
  const dispatch = useDispatch();
  const { tabs } = useParams();
  const { state } = useLocation();
  const { id, name, companyId, cityLocation, cityLocationId } = state;
  const navigate = useNavigate();
  const subVendorData = useSelector(
    (state) => state?.userSubVendor?.userSubVendor?.data
  );
  const driverData = useSelector(
    (state) => state?.userDriver?.userDriver?.data
  );
  const vehicleData = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );
  const vendorUserData = useSelector(
    (state) => state?.userVendorUser?.userVendorUser?.data
  );
  const postAddVehicleSuccess = useSelector(
    (state) => state?.userAddVehicle?.userAddVehicle?.success
  );
  const loadersubVendor = useSelector((state) => state?.userSubVendor?.loading);
  const loaderDriver = useSelector((state) => state?.userDriver?.loading);
  const loaderVehicle = useSelector((state) => state?.userVehicle?.loading);
  const loaderUser = useSelector((state) => state?.userVendorUser?.loading);
  const loader = useSelector((state) => state?.userVendor?.loading);
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });
  const locationList = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const locationOption = locationList?.map((val, idx) => {
    return { value: val?.id, label: val?.name };
  });

  const defaultSubVendor = {
    name: name,
  };
  const defaultUser = {
    city: cityLocation,
  };
  const [formData, setFormData] = useState(
    tabs == "2"
      ? driverDialogData
      : tabs === "3"
      ? vehicleDialogData(carOption?.length > 0 ? carOption : [])
      : subVendorDialogData
  );
  const [tableData, setTableData] = useState(
    tabs == "2" ? driverData : tabs === "3" ? vehicleData : subVendorData || {}
  );
  const [type, setType] = useState("Sub-Vendor");
  const [buttonText, setButtonText] = useState("Sub-Vendor +");
  const [value, setValue] = useState(tabs ? tabs : "1");
  const [open, setOpen] = useState(false);
  const [iconType, setIconType] = useState("Edit");
  const [iconId, setIconId] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [status, setStatus] = useState(
    vendorStatus?.length > 0 ? vendorStatus : ""
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterLocation, setFilterLocation] = useState("")
  const [search, setSearch] = useState('');

  const tabChange = (tabValue) =>{

     if (tabValue === '1') {
      setButtonText('Sub-Vendor +');
      setType('Sub-Vendor');
      setFormData(subVendorDialogData);
      dispatch(getSubVendor(filterData));
      setTableData(subVendorData);
    } else if (tabValue === '2') {
      setButtonText('Driver +');
      setType('Driver');
      setFormData(driverDialogData);
      dispatch(getDriver(payload));
      setTableData(driverData);
    } else if (tabValue === '3') {
      setButtonText('Vehicle +');
      setType('Vehicle');
      setFormData(vehicleDialogData(carOption?.length > 0 ? carOption : []));
      dispatch(getVehicle({...payload, status: ""}));
      setTableData(vehicleData);
    }else if (tabValue === '4') {
      setButtonText('User +');
      setFormData(vendorDialogData(locationOption));
      dispatch(getVendoruser(filterData));
      setTableData(vendorUserData)
      setType('User');
    } else {
      setButtonText('');
    }
  }
  let filterData ={
    id: id,
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    location: filterLocation,
    pageSize: rowsPerPage,
    type: "vendor",
    search: search,
  };
  let payload = {
    id: companyId,
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    location: filterLocation,
    pageSize: rowsPerPage,
    type: "vendor",
    search: search,
  };

  useEffect(() => {
    dispatch(getCar());
    dispatch(getServiceCity());
    tabChange(tabs)
  }, []);

  useEffect(() => {
    if (tabs === "3" && !carList?.length) {
      setFormData(vehicleDialogData(carOption?.length > 0 ? carOption : []));
    }
  }, [carList]);

  useEffect(() => {
    if (type === "Driver") {
      setTableData(driverData);
    } else if (type === "Vehicle") {
      setTableData(vehicleData);
    } else if (type === "User") {
      setTableData(vendorUserData);
    } else {
      setTableData(subVendorData);
    }
  }, [driverData, subVendorData, vehicleData, vendorUserData]);

  const handleTabChange = (newValue) => {
    localStorage.removeItem("vendorStatus");
    navigate(`/vendor/${cityLocation}/${newValue}`, {
      state: {
        id: id,
        status: status,
        name: name,
        companyId: companyId,
        cityLocation: cityLocation,
        cityLocationId: cityLocationId,
      },
    });
    setValue(newValue);
    setPage(0);
    setStatus([])
    setSearch('')
    onRestFilter();
    tabChange(newValue);
  };

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const onSubmit = (val, code) => {
    if (type === "Driver") {
      const data = {
        mobile: val.number,
        firstName: val.driverName,
        lastName: "",
        altmobile: val.mobile,
        DOB: val.birthday,
        permanentaddress: val.permanentaddress,
        currentaddress: val.currentaddress,
        covid: val.covid,
        email: val.email,
        countryCode: code,
        parentId: id,
        vendorId: id,
        companyName: val.driverName + val.number,
      };
      dispatch(postAddDriver(data));
    } else if (type === "Vehicle") {
      const allData = {
        ...val,
        carType: "COC",
        seating: parseInt(val?.seating),
        id: companyId,
        type: "vendor",
        avtar: selectedImage,
      };
      let formData = new FormData();
      Object.keys(allData).map((val) => {
        formData.append(val, allData[val]);
      });
      dispatch(postAddVehicle(formData));
    } else if (type === "User") {
      const data = {
        mobile: val.number,
        firstName: val?.vendorName.trim(),
        lastName: "",
        email: val.email,
        countryCode: code,
        companyName: val?.vendorName.trim(),
        location: cityLocationId,
        id: id,
      };
      dispatch(postAddVendor(data));
    } else {
      const data = {
        mobile: val.number,
        firstName: "",
        lastName: "",
        email: val.email,
        countryCode: code,
        vendorId: id,
        companyName: val.vendorName,
      };
      dispatch(postAddSubVendor(data));
    }
  };

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    } else {
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const onEditProfile = (data, code) => {
    const profileData = {
      vendorId: id,
      data: {
        firstName: data?.vendorName,
        lastName: "",
        email: data?.email,
        countryCode: "+91",
        mobile: data?.number,
        companyName: data?.vendorName,
        address: data?.address,
        city: data?.city,
        state: data?.state,
      },
    };
    dispatch(patchUpdateVendor(profileData));
  };

  const onClickTableVendor = (val) => {
    localStorage.setItem("vendorStatus", JSON.stringify(status));
    if (value === "1") {
      navigate("/vendor/subvendor", {
        state: {
          subVendorId: val?.id,
          status: val?.status,
          name: val?.companyName,
          companyId: val?.companyId,
          cityLocationId: state?.cityLocationId,
          cityLocation: cityLocation,
        },
      });
    } else if (value === "2") {
      navigate("/vendor/driver", {
        state: {
          driverId: val?.id,
          status: val?.status,
          name: val?.name,
          id: val?.authId,
          tabName: "driver",
          cityLocation: cityLocation,
        },
      });
    } else if (value === "3") {
      navigate("/vendor/vehicle", {
        state: {
          vehicleId: val?.id,
          status: val?.status,
          name: val?.carModel,
          cityLocation: cityLocation,
        },
      });
    }
  };

  const onClickMoreIcon = (data, iconType) => {
    if (type === "Sub-Vendor" || type === "Driver") {
      let profileData = {}
      const value = {
        vendorName: data?.companyName,
        driverName: data?.name,
        email: data?.email,
        number: data?.mobile,
        address: data?.location,
        name: data?.vendorName,
      };
      setDefaultValue(value);
      setIconId(data.id);
      if (iconType === "Delete") {
      } else if (iconType === "Edit") {
        setIconType(iconType);
        setOpen(true);
      } else if (iconType === "Deactivate") {
        profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: "InActive",
          },
        };
      } else if (iconType === "Activate") {
        profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: "Active",
          },
        };
      } else if (iconType === "Block") {
        profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: "Blocked",
          },
        };
        if(type === 'Sub-Vendor' && iconType !== 'Edit'){
          dispatch(patchUpdateSubVendor({...profileData, id:companyId}));}
          else if(type === 'Driver' && iconType !== 'Edit'){
            dispatch(patchUpdateDriver({...profileData, parentId:companyId}))
          }
      } else if (iconType === 'Unblock') {
        const profileData = {
          subVendorId: data.id,
          driverId: data.id,
          data: {
            status: "Active",
          },
        };
      }
      if (type === "Sub-Vendor" && iconType.toLowerCase() !== "edit") {
        dispatch(patchUpdateSubVendor({ ...profileData, id: companyId }));
      } else if (type === "Driver" && iconType.toLowerCase() !== "edit") {
        dispatch(patchUpdateDriver({ ...profileData, parentId: companyId }));
      }
    } else if (type === "Vehicle") {
      const value = data;
      setDefaultValue(value);
      setIconId(data.id);
      if (iconType === "Edit") {
        setIconType(iconType);
        setOpen(true);
      } else if (iconType === "Upload Compliance") {
        setIconType(iconType);
        setOpen(true);
        const profileData = {
          vehicleId: data.id,
          type: "vehicleRegistration",
        };
        setShowOtherComponent(true);
        dispatch(getOnBoardCompliance(profileData));
      } else if (iconType === "Deactivate") {
        const profileData = {
          isApproved: "InActive",
          id: data?.id,
        };
        dispatch(patchUpdateVehicle({ ...profileData, cityId: companyId }));
      } else if (iconType === "Activate") {
        const profileData = {
          isApproved: "Active",
          id: data?.id,
        };
        dispatch(patchUpdateVehicle({ ...profileData, cityId: companyId }));
      }
    } else if (type === "User") {
      const value = {
        vendorName: data?.companyName.trim(),
        email: data?.email,
        number: data?.mobile,
        city: data?.location,
      }
      setDefaultValue(value)
      setIconId(data.id)
      if(type === 'Delete'){
      
      }else if(type === 'Edit') {
        setType(type)
        setIconType(iconType);
        setOpen(true);
      } else if (type === "Deactivate") {
        const profileData = {
          vendorId: data.id,
          data: {
            status: "InActive",
          },
        };
        dispatch(patchUpdateVendor(profileData));
      } else if (type === "Activate") {
        const profileData = {
          vendorId: data.id,
          data: {
            status: "Active",
          },
        };
        dispatch(patchUpdateVendor(profileData));
      } else if (type === "Block") {
        const profileData = {
          vendorId: data.id,
          data: {
            status: "Blocked",
          },
        };
        dispatch(patchUpdateVendor(profileData));
      } else if (type === "Unblock") {
        const profileData = {
          vendorId: data.id,
          data: {
            status: "Active",
          },
        };
        dispatch(patchUpdateVendor(profileData));
      }
    }
  };

  const onDialog = (data, code, val) => {
    if (type === "Sub-Vendor") {
      const profileData = {
        subVendorId: iconId,
        id: id,
        data: {
          firstName: data?.vendorName,
          lastName: "",
          email: data?.email,
          countryCode: "+91",
          mobile: data?.number,
          companyName: data?.vendorName,
          location: data?.address,
        },
      };
      dispatch(patchUpdateSubVendor(profileData));
    } else if (type === "Driver") {
      const profileData = {
        driverId: iconId,
        parentId: id,
        data: {
          firstName: data?.driverName,
          lastName: "",
          email: data?.email,
          countryCode: "+91",
          mobile: data?.number,
          companyName: "",
          location: data?.address,
        },
      };
      dispatch(patchUpdateDriver(profileData));
    } else if (type === "Vehicle") {
      const allData = {
        ...data,
        carType: "COC",
        seating: parseInt(data?.seating),
        id: companyId,
        type: "vendor",
        avtar: selectedImage,
      };
      let formData = new FormData();
      Object.keys(allData).map((val) => {
        formData.append(val, allData[val]);
      });
      dispatch(patchUpdateVehicle(formData));
    } else if (type === "User") {
      const profileData = {
        vendorId: id,
        data: {
          firstName: data?.vendorName,
          lastName: "",
          email: data?.email,
          countryCode: "+91",
          mobile: data?.number,
          companyName: data?.vendorName.trim(),
          location: data?.location,
        },
      };
      dispatch(patchUpdateVendor(profileData));
    }
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setShowOtherComponent(false);
  };

  const handleChangePage = (event,newPage) =>{
    setPage(newPage)
    if (value === '1'){
    dispatch(getSubVendor({...filterData, page:newPage}));
    } else if (value ==='2'){
    dispatch(getDriver({...payload, page:newPage}))
    } else if (value ==='3'){
      dispatch(getVehicle({...payload, page:newPage}))
    } else if(value == '4'){
      dispatch(getVendoruser({...filterData, page:newPage}))
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    if (value === '1'){
      dispatch(getSubVendor({...filterData, page:0, pageSize:parseInt(event.target.value)}));
      } else if (value ==='2'){
      dispatch(getDriver({...payload, page:0, pageSize:parseInt(event.target.value)}))
      } else if (value ==='3'){
        dispatch(getVehicle({...payload, page:0, pageSize:parseInt(event.target.value)}))
      } else if(value == '4'){
       dispatch(getVendoruser({...filterData, page:0, pageSize:parseInt(event.target.value)}))
      }
  }

  const onFilterChange = (val) => {
    localStorage.removeItem("vendorStatus");
    setPage(0);
    const defaultStatus = [
      "Active",
      "InActive",
      "Blocked",
      "Pending",
      "Rejected",
    ];

    const filterLocations = val.filter((location) => {
      return !defaultStatus.includes(location);
    });

    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });

    setStatus(filterStatus);
    setFilterLocation(filterLocations);

    if (value === "1") {
      filterData = {
        ...filterData,
        status: filterStatus?.toString(),
        location: filterLocations?.toString(),
        page: 0,
      };
      dispatch(getSubVendor(filterData));
    } else if (value === '2') {
      payload = {
        ...payload,
        status: filterStatus?.toString(),
        location: filterLocations?.toString(),
        page: 0,
      };
      dispatch(getDriver(payload));
    } else if (value === '3') {
      const vehicleFilterData = {
        ...payload,
        status: filterStatus?.toString(),
        location: filterLocations?.toString(),
        page: 0,
      };
      dispatch(getVehicle(vehicleFilterData));
    }
  };

  const onRestFilter = () => {
    localStorage.removeItem("vendorStatus");
    setStatus("");
    setPage(0);
    if (value === "1") {
      filterData = {
        ...filterData,
        status: "",
        page: 0,
      };
      dispatch(getSubVendor(filterData));
    } else if (value === '2') {
      payload = {
        ...payload,
        status: '',
        page: 0
      };
      dispatch(getDriver(payload));
    } else if (value === '3') {
      filterData = {
        ...payload,
        status: '',
        page: 0
      };
      dispatch(getVehicle(filterData));
    }
  }
  
  const onSearch = debounce((e) =>{
    setSearch(e);
    setPage(0)
   const searchFilterData = {
    ...filterData,search:e, page:0
   }
   if(value == '1') {
    dispatch((getSubVendor(searchFilterData)))
   }
   else if(value == '2'){
    let searchFilterDataDriver = {
      ...payload,search:e, page:0
    }
    dispatch((getDriver(searchFilterDataDriver)))
   }
   else if(value == '3'){
    dispatch((getVehicle(searchFilterData)))
   }
   else if(value == '4'){
    dispatch((getVendoruser(searchFilterData)))
   }
  },1000)

  const closeUploadCompliance = () => {
    setShowOtherComponent(false);
  };

  return (
    <div>
      <Breadcrumb
        buttonText={buttonText}
        formData={formData}
        type={type}
        onSubmittBtn={onSubmit}
        setSelectedImage={selectedImage}
        name={name}
        defaultValues={type === "User" ? defaultUser : defaultSubVendor}
        onImageChange={onImageChange}
        showOtherComponent={showOtherComponent}
        closeUploadCompliance={closeUploadCompliance}
        cityLocation={cityLocation}
      />
        <TabVendor
          defaultStatus={status}
          onTabChange={handleTabChange}
          TableData={tableData}
          onClickTable={onClickTableVendor}
          value={value}
          onClickMoreIcon={onClickMoreIcon}
          onFilterChange={onFilterChange}
          onRestFilter={onRestFilter}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          filterdata={type === 'Vehicle' ? filterStatusVehicle : filterStatusData}
          onSearch={onSearch}
          loaderDriver={loaderDriver}
          loaderVehicle={loaderVehicle}
          loadersubVendor={loadersubVendor}
          loaderUser={loaderUser}
          search={search}
        />

      {open && type !== "Vehicle" ? (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          type={"Edit " + type + " "}
          selectType={"edit"}
          defaultValues={defaultValue}
        />
      ) : null}

      {open && type === "Vehicle" && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          selectType={"edit"}
          type={'Upload Vehicle Compliance' }
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName="vehicle"
          vehicleId={iconId}
        />
      )}
    </div>
  );
}

export default ViewVendor;
